"use client";

import * as React from "react";

/**
 * フッターコンポーネント（常に画面最下部に表示されるよう親で flex + margin-top: auto または flex-shrink: 0 を指定すること）
 * スカンジナビア風・明るめのデザインでログイン画面と統一
 * @param {Object} props
 * @param {string} [props.mode] - ログイン等の mode（一部 mode では非表示）
 * @param {Object} [props.group] - グループ情報（CashBackRatio がある場合は非表示）
 */
const Footer = ({}) => {
  return (
    <footer className="mt-auto w-full min-w-full flex-shrink-0 bg-[#e8e4dc] text-[#3d3a36] py-4 border-t border-[#e0dcd4]">
      <div className="container mx-auto text-center text-sm">
        <p>
          Copyright(C){" "}
          <a
            href="https://www.direct-order.jp/"
            className="text-[#5c574f] hover:text-[#7d8b6f] transition-colors"
          >
            ダイレクトオーダー事務局
          </a>{" "}
          All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
